import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import TiremetrixSettingsHtml from './tiremetrix.settings.html';

export function TiremetrixStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'TiremetrixSettingsCtrl',
    name       : 'app.tiremetrix-settings',
    templateUrl: TiremetrixSettingsHtml,
    url        : '/tiremetrix-settings',
    resolve    : {
      integrations: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      quote       : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations/quote_for_tiremetrix'),
      session     : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh()
    }
  });
}
